import { createContext } from 'react';

import { Store, createStore } from '../../../../core/store/store.js';
import { MultiMeterBarChartState } from '../types/state.js';

export const MultiMeterBarChartStore = createContext<
  Store<MultiMeterBarChartState>
>(createStore<MultiMeterBarChartState>({} as MultiMeterBarChartState));

MultiMeterBarChartStore['displayName'] = 'MultiMeterBarChartStore';
